import React from 'react';
import { ContentTitle } from 'components/text';
import { colors } from 'constants/styles';
import { IsLoadingInline } from 'modules/isLoading/IsLoading';
const BalanceAmountLoading = () => (React.createElement("div", { className: "balance-block--loading" },
    React.createElement(ContentTitle, null, "Updating balance..."),
    React.createElement(IsLoadingInline, { color: colors.colorDarkSilverHex })));
export default BalanceAmountLoading;
